/* eslint-disable camelcase */
import { joinExisting } from "utils/strings";
import { EmployeeCardProps } from "./EmployeeCard";
import styles from "./EmployeeCard.module.scss";

export const Standard = ({
    employee,
    onClick,
    ...props
}: EmployeeCardProps) => {
    const {
        description,
        first_name,
        employee_photo,
        job_title,
        last_name,
    } = employee;
    const title = joinExisting([first_name, last_name]);
    return (
        <article {...props}>
            {!!employee_photo && (
                <figure className={styles.figure}>
                    <img className={styles.image} src={employee_photo} alt={title} loading="lazy" />
                    {!!onClick && (
                        <figcaption className={styles.figcap}>
                            <button
                                className={styles.cta}
                                onClick={onClick}
                                type="button"
                            >
                                Learn More
                            </button>
                        </figcaption>
                    )}
                </figure>
            )}
            <header className={styles.header}>
                <h3 className={styles.title}>{title}</h3>
                {!!job_title && <p className={styles.subheading}>{job_title}</p>}
            </header>
            {!!description && <p className={styles.description}>{description}</p>}
        </article>
    );
};
